<template>
  <el-container>
    <!-- <el-header height="48px">
      <el-row>
        <div class="top-left">
          <h3 class="table_title" style="line-height:20px;">新闻/发文列表</h3>
        </div>
        <div class="top-right">
          <el-button
            @click="back"
            style="margin-top :8px;"
            plain
            size="small"
            type="danger"
            icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </el-row>
    </el-header> -->
    <el-main class="new-table__content"  :style="conheight">
      <collapse-search>
      <div class="content_top_wrap">
        <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
        <el-row style="padding:8px 0px 8px 0px;">
          <el-col :span="24">
            <el-button size="small" type="primary" @click="search('find')">查询</el-button>
            <el-button size="small" @click="reset">重置</el-button>
          </el-col>
        </el-row>

        <!-- <el-input
          size="small"
          style="width:240px;"
          clearable
          placeholder="请输入关键词 主题/发起人"
          prefix-icon="el-icon-search"
          v-model="tableData"
          @keyup.enter.native="searchEnterFun"
        ></el-input>
        <div class="date_wrap">
          <p>发布时间</p>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
        <el-row>
          <el-col :span="24">
            <el-button
              style="margin-left: 20px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh"
              >重置</el-button
            >
            </el-col>
          </el-row> -->
      </div>
      </collapse-search>
      <!-- default-sort  排序 -->
      <el-table
        :data="rows"
        style="width: 100%;"
        header-cell-class-name="todo-header-row"
        row-class-name="todo-row"
        size="medium"
        height="95%"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <el-table-column
          type="index"
          width="45"
          align="center"
          label="序号"
        ></el-table-column>
        <el-table-column label="标题" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="display: flex;">
              <span v-if="scope.row.status=='0'" style="margin: 0px 8px 0px 0px;">
                <img src="/fvue/img/msg_own.png" >
              </span>
              <span v-else style="margin: 0px 8px 0px 0px;">
                <img src="/fvue/img/msg_none.png" >
              </span>
              <span class="todo-subject" @click="openParticulars(scope.row.id)">
                {{ scope.row.title }}
              </span>
            </div>
            <!-- <el-link :underline="false" @click="openParticulars(scope.row.id)" >{{scope.row.title}}</el-link> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="classifyName"
          label="所属分类"
          align="left"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          label="过期时间"
          show-overflow-tooltip
          align="left"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          align="left"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="createByName"
          label="创建人"
          align="left"
          show-overflow-tooltip
          width="95"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="left"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <!-- <el-table-column label="所属类型" show-overflow-tooltip width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.type == 1 ? "轮播图" : "新闻公告" }}</span>
          </template>
        </el-table-column> -->
      </el-table>
    </el-main>
    <el-footer height="45px;line-height: 45px;float: right ;">
      <el-row type="flex" justify="end">
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-row>
    </el-footer>
    <homeNewsParticulars ref="homeNewsParticulars" :id="selectId" />
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import homeNewsParticulars from "@/components/home/homeNewsParticulars.vue";
import utils from "@/utils.js";
import searchForm from "@/components/common/searchForm.vue";
export default {
  name: "newsList",
  components: { 
    homeNewsParticulars,
    searchForm
   },
  props: ["type", "classifyId"],
  data() {
    return {
      tableData: "",
      date: "",
      fullscreenLoading: true,
      selectId: null,
      conheight:{ height:'' },
      searchOptions: [
        {
          property: "title",
          operation: "LIKE",
          type: "text",
          label: "公告主题",
          placeholder: "请输入公告主题"
        },
        {
          property: "createByName",
          operation: "LIKE",
          type: "text",
          label: "创建人",
          placeholder: "请输入创建人"
        }
        ],
      User:JSON.parse(window.sessionStorage.currentUser)
    };
  },
  computed: mapState({
    rows: (state) =>{
      let data = [];
      for(let i=0;i<state.menu.rows.length;i++){
        if(state.menu.rows[i].start_=='启用'){
          data.push(state.menu.rows[i]);
        }
      }
      return data;
    },
    pagination: (state) => {
      return state.menu.pagination;
    },
    total: (state) => {
      let data = [];
      for(let i=0;i<state.menu.rows.length;i++){
        if(state.menu.rows[i].start_=='禁用'){
          data.push(state.menu.rows[i]);
        }
      }
      return state.menu.total-data.length;
    },
  }),
  methods: {
    getHeight() {
      this.conheight.height=window.innerHeight-175+'px';
    },

    openParticulars(id) {
      let param = {
        xm:this.User.username,
        gh:this.User.account,
        ggbt:"",
        ggbm:id,
      };
      window.app.$http.post(window.context.bpmRunTime + "/message/SaveNewsItem", param).then(resp => {//插入阅读记录表
        debugger;
      });
      this.selectId = id;
      this.$refs.homeNewsParticulars.openDialog();
    },
    //返回首页
    back() {
      this.$router.go(-1);
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("menu/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("menu/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {

      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      if (this.currentTree) {
        querys.push({
          property: "bt.type_id_",
          value: this.currentTree,
          group: "typeId",
          operation: "IN",
          relation: "AND"
        });
      }
      if (this.defKey) {
        querys.push({
          property: "bt.proc_def_key_",
          value: this.defKey,
          operation: "EQUAL",
          relation: "AND"
        });
      }

      let queryOB = {};
        if (this.classifyId) {
          queryOB = {
            property: "classifyId",
            value: this.classifyId,
            group: "advance",
            relation: "AND",
            operation: "EQUAL"
          };
          querys.push(queryOB);
        }

        queryFilter = {
          pageBean: this.pagination,
          querys: querys,
          sorter: [{ property: "createTime", direction: "DESC" }],
          params:{"gh":this.User.account}
        };
        this.$store
          .dispatch("menu/getNewsPaginationList", queryFilter)
          .then(() => {
            this.fullscreenLoading = false;
          });

      // this.openFullScreen();
      // if (str == "find") {
      //   this.$store.dispatch("menu/setPaginationPageNum", 1);
      // }
      // let querys = []; //查询条件
      // let queryFilter = {};
      // let pageBean = { pageBean: this.pagination, querys: [] };
      // let beginDate = ""; //开始时间
      // let endDate = ""; //结束时间
      // let group = "main"; //判断条件
      // let moment = require("moment");
      // if (this.tableData == "" && (this.date == "" || this.date == null)) {
      //   if (this.classifyId) {
      //     let queryOB = {
      //       property: "classifyId",
      //       value: this.classifyId,
      //       group: "advance",
      //       relation: "AND",
      //       operation: "EQUAL"
      //     };
      //     querys.push(queryOB);
      //   }
      //   queryFilter = {
      //     pageBean: this.pagination,
      //     querys: querys,
      //     sorter: [{ property: "createTime", direction: "DESC" }]
      //   };
      //   this.$store
      //     .dispatch("menu/getNewsPaginationList", queryFilter)
      //     .then(() => {
      //       this.fullscreenLoading = false;
      //     });
      // } else {
      //   if (this.tableData != "" && this.date != "" && this.date != null) {
      //     group = "time";
      //   }
      //   if (this.date != null && this.date != "" && this.tableData != "") {
      //     beginDate = moment(this.date[0].getTime()).format(
      //       "YYYY-MM-DD HH:mm:ss"
      //     );
      //     endDate = moment(this.date[1].getTime()).format(
      //       "YYYY-MM-DD HH:mm:ss"
      //     );
      //     querys = [
      //       {
      //         property: "title",
      //         value: this.tableData,
      //         group: "main",
      //         operation: "LIKE",
      //         relation: "OR"
      //       },
      //       {
      //         property: "createByName",
      //         value: this.tableData,
      //         group: "main",
      //         operation: "LIKE",
      //         relation: "OR"
      //       },

      //       {
      //         property: "createTime",
      //         value: [beginDate, endDate],
      //         group: group,
      //         operation: "BETWEEN",
      //         relation: "AND"
      //       }
      //     ];
      //   } else if (this.date != null && this.date != "") {
      //     beginDate = moment(this.date[0].getTime()).format(
      //       "YYYY-MM-DD HH:mm:ss"
      //     );
      //     endDate = moment(this.date[1].getTime()).format(
      //       "YYYY-MM-DD HH:mm:ss"
      //     );
      //     querys = [
      //       {
      //         property: "createTime",
      //         value: [beginDate, endDate],
      //         group: group,
      //         operation: "BETWEEN",
      //         relation: "AND"
      //       }
      //     ];
      //   } else {
      //     querys = [
      //       {
      //         property: "title",
      //         value: this.tableData,
      //         group: "main",
      //         operation: "LIKE",
      //         relation: "OR"
      //       },
      //       {
      //         property: "createByName",
      //         value: this.tableData,
      //         group: "main",
      //         operation: "LIKE",
      //         relation: "OR"
      //       }
      //     ];
      //   }
      //   let queryOB = {};
      //   if (this.classifyId) {
      //     queryOB = {
      //       property: "classifyId",
      //       value: this.classifyId,
      //       group: "advance",
      //       relation: "AND",
      //       operation: "EQUAL"
      //     };
      //     querys.push(queryOB);
      //   }
      //   queryFilter = {
      //     pageBean: this.pagination,
      //     querys: querys,
      //     sorter: [{ property: "createTime", direction: "DESC" }]
      //   };
      //   this.$store
      //     .dispatch("menu/getNewsPaginationList", queryFilter)
      //     .then(() => {
      //       this.fullscreenLoading = false;
      //     });
      // }
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    }
  },
  mounted(){
    window.jQuery(".el-main").css({"overflow":"hidden"});
    window.jQuery(".is-scrolling-none").css({"height":window.innerHeight-220+"px !important"});
        //页面高度设置
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
  },
  created() {
    let query = [];
    if (this.classifyId) {
      query = [
        {
          property: "classifyId",
          value: this.classifyId,
          group: "advance",
          relation: "AND",
          operation: "EQUAL"
        }
      ];
    }
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys: query,
      sorter: [{ property: "createTime", direction: "DESC" }],
      params:{"gh":this.User.account}
    }; //初次加载默认pageBean
    this.$store.dispatch("menu/getNewsPaginationList", pageBean).then(() => {
      //页面加载调用tudo.js里面的分页方法
      this.fullscreenLoading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";


/deep/.el-table th{
  height: 48px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}

// /deep/.el-table--border tr:nth-child(even){
//     background: rgb(240, 241, 241);
// }

/deep/.el-table th,
/deep/.el-table td {
  //border-right:1px dashed #000000;
  border-bottom: 1px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

/deep/.el-table tr:hover > td{
    background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
}

/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}


/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
  height: 48px;
}

.el-container {
  background-color: #fff;
}

.table_title {
  font-size: 14px;
  margin: 17px 0 0 0;
  padding: 0 0 12px 0;
}

.el-row {
  margin-bottom: 10px;
}
/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 0px;

  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.el-header {
  border-bottom: 1.5px solid #ededed;
}

.todo-subject {
  cursor: pointer;
}
/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.todo-subject {
  color: $--theme-color;
}

.top-left {
  display: inline-block;
}
.top-right {
  display: inline-block;
}
.new-table__content {
  padding-top: 0;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin:0px 0 8px 0px;
  flex-wrap: wrap;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
/deep/ .el-collapse-item__header {
  padding-left: 0;
}
/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 
/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}
</style>
